import { Box, Input, Loading } from 'ui'
import { useCompanyMembersContext } from '../context/CompanyMembersProvider'

export const Filter = () => {
  const {
    state: { searchTerm, isLoading },
    actions: { setSearchTerm },
  } = useCompanyMembersContext()

  return (
    <Input
      placeholder="Search by name or email"
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      rightContent={
        isLoading ? (
          <Box p={2}>
            <Loading type="button" />
          </Box>
        ) : null
      }
    />
  )
}
